import React from "react";
import { cn } from "@/lib/utils/cn";

interface EntityPreviewFrameProps {
  children: React.ReactNode;
  backgroundUrl?: string | null;
  disabled?: boolean;
  className?: string;
}

export const EntityPreviewFrame = ({
  children,
  backgroundUrl,
  disabled,
  className,
}: EntityPreviewFrameProps) => {
  return (
    <div
      className={cn(
        "relative flex h-full w-full items-center justify-center overflow-hidden rounded-xl bg-slate-100/50 p-2",
        disabled && "opacity-60 grayscale",
        className,
      )}
    >
      {backgroundUrl ? (
        <>
          <img
            src={backgroundUrl}
            alt=""
            aria-hidden="true"
            className="pointer-events-none absolute inset-[-22%] h-[144%] w-[144%] scale-125 object-cover opacity-35 blur-3xl saturate-150"
            loading="lazy"
            decoding="async"
          />
          <div className="pointer-events-none absolute inset-0 bg-white/55 backdrop-blur-[1px]" />
        </>
      ) : null}
      <div className="relative z-10 flex h-full w-full items-center justify-center drop-shadow">
        {children}
      </div>
    </div>
  );
};
